const borderRadius = {
	image: '50px',
};

export default borderRadius;
